<template>
  <div class="state-box">
    <h4>{{ head }}</h4>
    <p>
      <strong>{{
        type == "money" ? "£" + numberWithCommas(state) : state
      }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "stock-state",
  props: ["head", "state", "type"],
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style scoped lang="scss">
.state-box {
  height: 60px;
  padding: 10px;
  float: left;
  width: 150px;
  border: 1px solid #eee;
  margin-right: 10px;
  -webkit-box-shadow: 5px 10px #888888;
  box-shadow: 2px 2px #eee;

  h4 {
    font-size: 16px;
    color: #007bff;
  }
  p {
    font-size: 12px;
    color: #646464;
  }
}
</style>
